<template>
	<div class="pageTitle">
		<ul>
			<h3 class="tit">
				<slot>{{tit}}</slot>
			</h3>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'PageTitle',
		props: {
			tit: {
				type: String
			},
			//			icon:{
			//				
			//			}
		}
	}
</script>
<style lang="scss" >
	.pageTitle {
		width: 88%;
		text-align: left;
		/*border: ;*/
		padding: 11px 0;
		margin-left: 22px;
		background-color: #ecf8ff;
		border-radius: 5px;
		/*border-left: 5px solid #50bfff;*/
		.tit {
			color: #666666;
			padding: 0 15px;
			overflow: hidden;
		}
	}
</style>